import React from "react";
import "./styles/Video.css";
import Wave from "../components/Wave";
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

const Video = () => {
  // Intersect Observer ( Checks if component is in view ) 
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (

    <div className="video-section">


      <motion.div
        ref={ref}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={inView ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="video-container"
      >
        <iframe
          src="https://player.vimeo.com/video/1090772983?h=2518a8e958&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          className="video"
          allow="autoplay; fullscreen; picture-in-picture"

        ></iframe>
      </motion.div>
    </div>
  );
};

export default Video;
